import { Box } from '@mui/material'
import type { ReactNode } from 'react'

function TableCellContentWithTooltip({
  tooltip,
  children
}: Readonly<{
  tooltip: ReactNode
  children: ReactNode
}>) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ float: 'left' }}>{tooltip}</Box>
      {children}
    </Box>
  )
}

export default TableCellContentWithTooltip
